import { useState } from 'react';
import { navLinks, siteMeta } from '@/mocks/home';

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1320px] items-center justify-between gap-4 px-5 md:h-20 md:px-8">
        <h1 className="flex shrink-0 items-baseline gap-2">
          <a
            href="#cover"
            className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl"
          >
            黑料专区
          </a>
          <span className="hidden font-label text-[10px] uppercase tracking-editorial text-primary-600 sm:inline">
            {siteMeta.latin}
          </span>
        </h1>

        <nav className="hidden items-center gap-9 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="whitespace-nowrap font-label text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <div className="hidden items-center rounded-full border border-background-300/70 bg-background-100/70 md:flex">
            <button
              type="button"
              aria-label="搜索猛料"
              onClick={() => setSearchOpen((v) => !v)}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-foreground-600 transition-colors hover:text-primary-600"
            >
              <i className={`text-base ${searchOpen ? 'ri-close-line' : 'ri-search-line'}`} />
            </button>
            <input
              type="text"
              placeholder="搜索今日猛料"
              className={`border-0 bg-transparent font-label text-sm text-foreground-800 outline-none transition-all duration-300 ${
                searchOpen ? 'w-44 pr-4 opacity-100' : 'w-0 opacity-0'
              }`}
            />
          </div>

          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅速递
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300/70 text-foreground-700 transition-colors hover:text-primary-600 lg:hidden"
          >
            <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50/95 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1320px] flex-col px-5 pb-5 pt-2 md:px-8">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-200/60 py-3 font-label text-sm text-foreground-700 last:border-b-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-4 rounded-full bg-primary-500 px-5 py-3 text-center font-label text-sm font-medium text-background-50"
            >
              订阅猛料速递
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}